<template>
    <div>
        <div class="navigation__wrap">
            <div
                class="navigation__container"
                :class="{
                    'min-h-100':
                        !$store.state.isShow645 || !$store.state.isShow590,
                }"
            >
                <div
                    v-show="$store.state.isShow645 || $store.state.isShow590"
                    class="navigation__bestslip"
                    @click="handleToggleBetslip()"
                >
                    <p>
                        {{ getTranslatedText("Betslip") }}
                        <span>{{ $store.state.quantity }}</span>
                    </p>
                    <button v-if="!isOpenBetslip">
                        <img src="~ThemePath/images/chevron.png" alt="" />
                    </button>
                    <button
                        v-if="isOpenBetslip"
                        class="navigation__bestslip__icon-down"
                    >
                        <img src="~ThemePath/images/chevron.png" alt="" />
                    </button>
                </div>
                <div class="navigation__content">
                    <ul class="navigation__content--list">
                        <li @click="navigateMenu('/')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/home.png"
                                        alt="home" /></span
                                ><span>{{ getTranslatedText("home") }}</span></a
                            >
                        </li>
                        <li
                            v-if="$store.state.isShowSports"
                            @click="navigateMenu('/sports')"
                        >
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/sports.png"
                                        alt="sports" /></span
                                ><span>{{
                                    getTranslatedText("sport")
                                }}</span></a
                            >
                        </li>
                        <li v-if="$store.state.isShowSports" @click="navigateMenu('/voucher')" >
                            <a>
                                <span>
                                    <img
                                        src="~ThemePath/images/voucher.png"
                                        alt="sports" />
                                </span>
                                <span> {{ getTranslatedText("vouchers")}} </span>
                            </a>
                        </li>
                        <li @click="navigateMenu('/history')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/report.png"
                                        alt="history" /></span
                                ><span>{{
                                    getTranslatedText("historique")
                                }}</span></a
                            >
                        </li>
                        <li @click="navigateMenu('/scan-ticket')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/scan.png"
                                        alt="scan" /></span
                                ><span>{{ getTranslatedText("scan") }}</span></a
                            >
                        </li>
                        <li @click="navigateMenu('/report')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/report.png"
                                        alt="report" /></span
                                ><span>{{
                                    getTranslatedText("report")
                                }}</span></a
                            >
                        </li>
                        <li @click="navigateMenu('/report-final')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/report.png"
                                        alt="report" /></span
                                ><span>{{
                                    getTranslatedText("report final")
                                }}</span></a
                            >
                        </li>
                        <li
                            v-if="
                                $store.state.isShow645 || $store.state.isShow590
                            "
                            @click="navigateMenu('/results')"
                        >
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/result.png"
                                        alt="result" /></span
                                ><span>{{
                                    getTranslatedText("result")
                                }}</span></a
                            >
                        </li>
                        <li
                            v-if="
                                $store.state.isShow645 || $store.state.isShow590
                            "
                            @click="navigateMenu('/about')"
                        >
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/about.png"
                                        alt="about" /></span
                                ><span>{{
                                    getTranslatedText("about")
                                }}</span></a
                            >
                        </li>
                        <li @click="navigateMenu('/print')">
                            <a
                                ><span
                                    ><img
                                        src="~ThemePath/images/print.png"
                                        alt="print" /></span
                                ><span>{{
                                    getTranslatedText("print")
                                }}</span></a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-if="isOpenBetslip">
            <Cart
                @close-cart="handleToggleBetslip"
                @continue-paying="handleContinuePaying"
            ></Cart>
        </div>
    </div>
</template>
<style lang="scss">
@import "~ThemePath/scss/navigation/_index.scss";
</style>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import Cart from "@/views/cart/index.vue";
import EventBus from "@/utils/EventBus";
export default {
    components: {
        Cart,
    },
    mixins: [languageMixins],
    data() {
        return {
            isOpenBetslip: false,
            dataCart: {
                cart: [],
                quantity: 0,
                transact: [],
                totalCart: 0,
            },
        };
    },
    methods: {
        navigateMenu(url) {
            let history = this.$router.history.current.path;
            this.isOpenBetslip = false;
            parent.postMessage(
                { command: "is-show-cammera", param: false },
                "*"
            );
            EventBus.$emit("on-hide-camere-scan");

            if (
                (history === "/report" && url === "/report-final") ||
                (history === "/report-final" && url === "/report")
            ) {
                let isFinal = url === "/report-final" ? true : false;
                EventBus.$emit("on-report", {
                    isFinal: isFinal,
                });
            }

            this.$router.push(url);
        },
        handleToggleBetslip() {
            this.isOpenBetslip = !this.isOpenBetslip;
        },
        handleContinuePaying() {
            this.isOpenBetslip = false;
            this.$router.push("/");
        },
    },
};
</script>
